import { Link } from 'react-router-dom'
import { useCollection } from '../../hooks/useFirestore'
import './AdminEditor.css'

const PLACEHOLDER_ART = 'data:image/svg+xml,' + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <rect fill="#1E1A22" width="100" height="100"/>
    <circle cx="50" cy="50" r="30" fill="none" stroke="#6E2EBF" stroke-width="2"/>
    <circle cx="50" cy="50" r="10" fill="#6E2EBF"/>
  </svg>
`)

// Get primary cover: images.front first, then legacy coverArtUrl
function getCoverArt(album) {
  return album.images?.front || album.coverArtUrl || PLACEHOLDER_ART
}

export default function AlbumList() {
  const { data: albums, loading: albumsLoading } = useCollection('albums', { orderByField: 'sortOrder' })
  const { data: songs } = useCollection('songs')

  // Count songs per album
  const songCounts = songs.reduce((acc, song) => {
    acc[song.albumId] = (acc[song.albumId] || 0) + 1
    return acc
  }, {})

  if (albumsLoading) {
    return (
      <div className="container">
        <div className="loading-spinner" />
      </div>
    )
  }

  return (
    <div className="container">
      <div className="editor-header">
        <h1>Albums & Songs</h1>
        <Link to="/admin/albums/new" className="btn btn-primary">
          + New Album
        </Link>
      </div>

      {albums.length === 0 ? (
        <div className="empty-state">
          <p>No albums yet.</p>
          <p className="text-secondary">Create your first album to start adding songs.</p>
        </div>
      ) : (
        <div className="admin-list">
          {albums.map(album => (
            <Link
              key={album.id}
              to={`/admin/albums/${album.id}`}
              className="admin-list-item"
            >
              <div className="item-image">
                <img
                  src={getCoverArt(album)}
                  alt={album.title}
                  onError={(e) => { e.target.src = PLACEHOLDER_ART }}
                />
              </div>
              <div className="item-info">
                <h3>{album.title}</h3>
                <p className="text-secondary">
                  {album.artist}
                  {album.copyrightYear && ` • ${album.copyrightYear}`}
                </p>
              </div>
              <span className="item-badge badge-pc">
                {songCounts[album.id] || 0} tracks
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
